// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}
.header-block {
  background-color: rgba(43, 42, 41, 0.8980392157);
  border-bottom: 1px solid rgba(67, 66, 66, 0.4);
  backdrop-filter: blur(10px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.header-block .line {
  border-top: 1px solid rgba(67, 66, 66, 0.4);
}
.header-block-row {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-block-row-left {
  display: flex;
  align-items: center;
}
.header-block-row-left-item {
  margin-right: 32px;
  cursor: pointer;
}
.header-block-row-left-item a {
  text-decoration: none;
}
.header-block-row-left-item span {
  font-size: 14px;
  font-weight: 400;
  color: #898989;
}
.header-block-row-left-item:hover span {
  color: #6E00FF;
}
.header-block-row-left-empty {
  width: 85px;
}
.header-block-row-center {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.header-block-row-right {
  display: flex;
  align-items: center;
}
.header-block-row-right-number {
  font-size: 14px;
  font-weight: 400;
  color: #898989;
  margin-right: 32px;
}
.header-block-row-right-lang {
  display: flex;
  align-items: center;
  margin-right: 32px;
  cursor: pointer;
  position: relative;
}
.header-block-row-right-lang span {
  margin-left: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #898989;
}
.header-block-row-right-lang-menu {
  position: absolute;
  top: 25px;
  left: 0;
  z-index: 999;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}
.header-block-row-right-lang-menu-item {
  width: 60px;
  height: 25px;
  padding: 5px;
  border-bottom: 1px solid rgba(67, 66, 66, 0.4);
  display: flex;
  align-items: center;
  cursor: pointer;
}
.header-block-row-right-lang-menu-item span {
  margin-left: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #898989;
}
.header-block-row-right-lang-menu-item:first-child {
  border-radius: 5px 5px 0 0;
}
.header-block-row-right-lang-menu-item:last-child {
  border-bottom: 0;
  border-radius: 0 0 5px 5px;
}
.header-block-row-right-lang-menu-item:hover {
  background-color: rgba(43, 42, 41, 0.8980392157);
}
.header-block-row-right-lang-menu-item:hover span {
  color: #6E00FF;
}
.header-block-row-right-search {
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  outline: none;
}
.header-block-row-categories {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-block-row-categories-item {
  width: 100%;
  height: 34px;
  box-sizing: border-box;
  border-right: 1px solid rgba(67, 66, 66, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.header-block-row-categories-item span {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  max-width: 110px;
}
.header-block-row-categories-item:first-child {
  width: auto;
  justify-content: flex-start;
  border-right: 0;
}
.header-block-row-categories-item:first-child span {
  display: none;
}
.header-block-row-categories-item:first-child:hover svg {
  fill: #6E00FF;
}
.header-block-row-categories-item:first-child:hover svg path {
  stroke: #6E00FF;
}
.header-block-row-categories-item-subcat {
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  min-height: 50px;
  background-color: rgba(43, 42, 41, 0.8980392157);
  display: flex;
  flex-direction: column;
}
.header-block-row-categories-item-subcat-item {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(67, 66, 66, 0.4);
}
.header-block-row-categories-item-subcat-item-name {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  max-width: 110px;
}
.header-block-row-categories-item-subcat-item-name:hover {
  color: #6E00FF;
}
.header-block-row-categories-item:hover span {
  color: #6E00FF;
}

.ReactModal__Overlay {
  background-color: rgba(0, 0, 0, 0.75) !important;
  z-index: 2 !important;
}

@media (max-width: 1024px) {
  .header-block-row {
    height: 50px;
  }
  .header-block-row-center svg {
    width: 120px;
  }
  .header-block-row-right-number {
    font-size: 12px;
  }
  .header-block-row-right-lang svg {
    width: 20px;
    height: 20px;
  }
  .header-block-row-right-lang span {
    font-size: 12px;
  }
  .header-block-row-right button svg {
    width: 20px;
    height: 20px;
  }
  .header-block-row-categories-item svg {
    width: 26px;
    height: 26px;
  }
  .header-block-row-categories-item span {
    font-size: 12px;
  }
}
@media (max-width: 768px) {
  .header-block-row-left-item {
    margin-right: 0;
  }
  .header-block-row-left-empty {
    display: none;
  }
  .header-block-row-right-number {
    display: none;
  }
  .header-block-row-categories-item {
    display: none;
  }
  .header-block-row-categories-item svg {
    display: none;
  }
  .header-block-row-categories-item span {
    font-size: 12px;
  }
  .header-block-row-categories-item:first-child {
    display: flex;
    width: 100%;
    border-right: 1px solid rgba(67, 66, 66, 0.4);
  }
  .header-block-row-categories-item:first-child span {
    display: block;
  }
}
@media (max-width: 576px) {
  .header-block-row {
    height: 50px;
  }
  .header-block-row-center svg {
    width: 90px;
  }
  .header-block-row-right-lang svg {
    width: 20px;
    height: 20px;
  }
  .header-block-row-right-lang span {
    font-size: 12px;
  }
  .header-block-row-right button svg {
    width: 20px;
    height: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AACF;AAAE;EACE,gDAAA;EACA,8CAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AADI;EACE,2CAAA;AAGN;AADI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAGN;AAFM;EACE,aAAA;EACA,mBAAA;AAIR;AAHQ;EACE,kBAAA;EACA,eAAA;AAKV;AAJU;EACE,qBAAA;AAMZ;AAJU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAMZ;AAJU;EACE,cAAA;AAMZ;AAHQ;EACE,WAAA;AAKV;AAFM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAIR;AAFM;EACE,aAAA;EACA,mBAAA;AAIR;AAHQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAKV;AAHQ;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAKV;AAJU;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAMZ;AAJU;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,+CAAA;AAMZ;AALY;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAOd;AANc;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAQhB;AANc;EACE,0BAAA;AAQhB;AANc;EACE,gBAAA;EACA,0BAAA;AAQhB;AANc;EACE,gDAAA;AAQhB;AAPgB;EACE,cAAA;AASlB;AAHQ;EACE,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;AAKV;AAFM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAIR;AAHQ;EACE,WAAA;EACA,YAAA;EAEA,sBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAIV;AAHU;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAKZ;AAHU;EACE,WAAA;EACA,2BAAA;EACA,eAAA;AAKZ;AAJY;EACE,aAAA;AAMd;AAJY;EACE,aAAA;AAMd;AALc;EACE,eAAA;AAOhB;AAHU;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;AAKZ;AAJY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8CAAA;AAMd;AALc;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAOhB;AANgB;EACE,cAAA;AAQlB;AAHU;EACE,cAAA;AAKZ;;AAMA;EACE,gDAAA;EACA,qBAAA;AAHF;;AAMA;EAGM;IACE,YAAA;EALN;EAOQ;IACE,YAAA;EALV;EASQ;IACE,eAAA;EAPV;EAUU;IACE,WAAA;IACA,YAAA;EARZ;EAUU;IACE,eAAA;EARZ;EAYU;IACE,WAAA;IACA,YAAA;EAVZ;EAgBU;IACE,WAAA;IACA,YAAA;EAdZ;EAgBU;IACE,eAAA;EAdZ;AACF;AAsBA;EAKU;IACE,eAAA;EAxBV;EA0BQ;IACE,aAAA;EAxBV;EA4BQ;IACE,aAAA;EA1BV;EA8BQ;IACE,aAAA;EA5BV;EA6BU;IACE,aAAA;EA3BZ;EA6BU;IACE,eAAA;EA3BZ;EA6BU;IACE,aAAA;IACA,WAAA;IACA,6CAAA;EA3BZ;EA4BY;IACE,cAAA;EA1Bd;AACF;AAuCA;EAGM;IACE,YAAA;EAvCN;EAyCQ;IACE,WAAA;EAvCV;EA4CU;IACE,WAAA;IACA,YAAA;EA1CZ;EA4CU;IACE,eAAA;EA1CZ;EA8CU;IACE,WAAA;IACA,YAAA;EA5CZ;AACF","sourcesContent":[".header {\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  &-block {\n    background-color: #2b2a29e5;\n    border-bottom: 1px solid #43424266;\n    backdrop-filter: blur(10px);\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    & .line {\n      border-top: 1px solid #43424266;\n    }\n    &-row {\n      width: 100%;\n      height: 64px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      &-left {\n        display: flex;\n        align-items: center;\n        &-item {\n          margin-right: 32px;\n          cursor: pointer;\n          & a {\n            text-decoration: none;\n          }\n          & span {\n            font-size: 14px;\n            font-weight: 400;\n            color: #898989;\n          }\n          &:hover span {\n            color: #6E00FF;\n          }\n        }\n        &-empty {\n          width: 85px;\n        }\n      }\n      &-center {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n      }\n      &-right {\n        display: flex;\n        align-items: center;\n        &-number {\n          font-size: 14px;\n          font-weight: 400;\n          color: #898989;\n          margin-right: 32px;\n        }\n        &-lang {\n          display: flex;\n          align-items: center;\n          margin-right: 32px;\n          cursor: pointer;\n          position: relative;\n          & span {\n            margin-left: 6px;\n            font-size: 14px;\n            font-weight: 400;\n            color: #898989;\n          }\n          &-menu {\n            position: absolute;\n            top: 25px;\n            left: 0;\n            z-index: 999;\n            border-radius: 5px;\n            background-color: #ffffff;\n            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);\n            &-item {\n              width: 60px;\n              height: 25px;\n              padding: 5px;\n              border-bottom: 1px solid #43424266;\n              display: flex;\n              align-items: center;\n              cursor: pointer;\n              & span {\n                margin-left: 6px;\n                font-size: 14px;\n                font-weight: 400;\n                color: #898989;\n              }\n              &:first-child {\n                border-radius: 5px 5px 0 0;\n              }\n              &:last-child {\n                border-bottom: 0;\n                border-radius: 0 0 5px 5px;\n              }\n              &:hover {\n                background-color: #2b2a29e5;\n                & span {\n                  color: #6E00FF;\n                }\n              }\n            }\n          }\n        }\n        &-search {\n          background-color: transparent;\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          border: 0;\n          outline: none;\n        }\n      }\n      &-categories {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        &-item {\n          width: 100%;\n          height: 34px;\n          // padding: 0 25px;\n          box-sizing: border-box;\n          border-right: 1px solid #43424266;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          cursor: pointer;\n          position: relative;\n          & span {\n            text-align: center;\n            font-size: 14px;\n            font-weight: 500;\n            color: #ffffff;\n            max-width: 110px;\n          }\n          &:first-child {\n            width: auto;\n            justify-content: flex-start;\n            border-right: 0;\n            & span {\n              display: none;\n            }\n            &:hover svg {\n              fill: #6E00FF;\n              & path {\n                stroke: #6E00FF;\n              }\n            }\n          }\n          &-subcat {\n            position: absolute;\n            top: 50px;\n            left: 0;\n            width: 100%;\n            min-height: 50px;\n            background-color: #2b2a29e5;\n            display: flex;\n            flex-direction: column;\n            &-item {\n              width: 100%;\n              height: 50px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              border-bottom: 1px solid #43424266;\n              &-name {\n                text-align: center;\n                font-size: 14px;\n                font-weight: 500;\n                color: #ffffff;\n                max-width: 110px;\n                &:hover {\n                  color: #6E00FF;\n                }\n              }\n            }\n          }\n          &:hover span {\n            color: #6E00FF;\n          }\n          // &:hover &-subcat {\n          //   display: flex;\n          // }\n        }\n      }\n    }\n  }\n}\n\n.ReactModal__Overlay {\n  background-color: rgba(0, 0, 0, 0.75) !important;\n  z-index: 2 !important;\n}\n\n@media (max-width: 1024px) {\n  .header {\n    &-block {\n      &-row {\n        height: 50px;\n        &-center {\n          & svg {\n            width: 120px;\n          }\n        }\n        &-right {\n          &-number {\n            font-size: 12px;\n          }\n          &-lang {\n            & svg {\n              width: 20px;\n              height: 20px;\n            }\n            & span {\n              font-size: 12px;\n            }\n          }\n          & button {\n            & svg {\n              width: 20px;\n              height: 20px;\n            }\n          }\n        }\n        &-categories {\n          &-item {\n            & svg {\n              width: 26px;\n              height: 26px;\n            }\n            & span {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .header {\n    &-block {\n      &-row {\n        &-left {\n          &-item {\n            margin-right: 0;\n          }\n          &-empty {\n            display: none;\n          }\n        }\n        &-right {\n          &-number {\n            display: none;\n          }\n        }\n        &-categories {\n          &-item {\n            display: none;\n            & svg {\n              display: none;\n            }\n            & span {\n              font-size: 12px;\n            }\n            &:first-child {\n              display: flex;\n              width: 100%;\n              border-right: 1px solid rgba(67, 66, 66, 0.4);\n              & span {\n                display: block;\n              }\n            }\n            // &:last-child {\n            //   display: flex;\n            //   border-right: 0;\n            // }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .header {\n    &-block {\n      &-row {\n        height: 50px;\n        &-center {\n          & svg {\n            width: 90px;\n          }\n        }\n        &-right {\n          &-lang {\n            & svg {\n              width: 20px;\n              height: 20px;\n            }\n            & span {\n              font-size: 12px;\n            }\n          }\n          & button {\n            & svg {\n              width: 20px;\n              height: 20px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
